export default __webpack_public_path__ + "static/media/ecx.061b69cc.svg";